import routerOptions0 from "/app/cms_public/node_modules/.pnpm/nuxt@3.18.0_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.0.3_@vue+compiler-sfc@3_bicqmvvwden2mvnhplzxekrfu4/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/app/cms_public/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}